import script from "./AddCharge.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCharge.vue?vue&type=script&setup=true&lang=js"

import "./AddCharge.vue?vue&type=style&index=0&id=578222c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-578222c0"]])

export default __exports__